import * as React from "react";
import { FormattedMessage } from "react-intl";

import { StampContext } from "tp/shared/timeclock/messages";
import { ConfirmationDialog } from "../ConfirmationDialog";
import { ConfirmMultiStampProps, StampDirection } from "tp/shared/timeclock/models";
import { ReactElement } from "react";

export class ConfirmMultiStamp extends React.Component<ConfirmMultiStampProps> {
    render(): ReactElement {
        const direction = StampDirection[this.props.stampDirection];
        return (
            <div className="stampform">
                <ConfirmationDialog
                    header={<FormattedMessage {...StampContext.AlreadyStampedHeader} values={{ direction }} />}
                    message={<FormattedMessage {...StampContext.AlreadyStampedConfirm} values={{ direction }} />}
                    enableYesButton={true}
                    enableNoButton={true}
                    confirmationClickedHandler={this.props.onClickHandler} />
            </div>
        );
    }
}
